import React from 'react';
import { Link } from 'react-router-dom';

import './breadcrumbs.styles.scss';

export const Breadcrumbs = ({title}) => (
    <div className="breadcrumbs">
        <div className="container">
            <Link to="/tourism-community-stories">Home</Link>
            <span className="divider">&#xbb;</span>
            <Link to="/tourism-community-stories/#crowdriff-use-case">CrowdRiff Use Cases</Link>
            <span className="divider">&#xbb;</span>
            <span>{title}</span>
        </div>
    </div>
)